import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IActTeamMemberActions, IThunkActivateTeamMember } from '../types';

const onActivateTeamMember: IThunkActivateTeamMember = thunk(
  async ({ activateTeamMember }: Actions<IActTeamMemberActions>, payload) => {
    const { clinicId, actTeamId, teamMemberId } = payload;

    await api.actTeamMember.activateTeamMember(clinicId, actTeamId, teamMemberId);

    activateTeamMember(teamMemberId);
  },
);

export default onActivateTeamMember;
